module.exports = __webpack_public_path__ + "static/media/collab-background.90e33512.png";